import { Component, Inject, OnInit, TemplateRef, ViewChild, inject, ElementRef } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';

import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { uploadData } from "aws-amplify/storage";
import { NgbModal, ModalDismissReasons, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle, MatDialogModule } from "@angular/material/dialog";
import { ActivityCreationPageComponent } from '../activity-creation-page/activity-creation-page.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { environment } from 'src/environments/environment';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTable, MatTableModule } from '@angular/material/table';
import { ProgressComponent } from '../../common/progress/progress.component';
import { ServiceService } from '../../../services/service.service';
import { StorageService } from '../../../services/storage.service';
import { CommonModule } from '@angular/common';

export interface DialogData {
  storeId: string;
}

export interface TimeSlotsI {
  timeSlot: string;
  personSlots: number;
}
export interface AvailabilityI {
  availabilityDate: number;
  dateFormated: string;
  timeSlots: TimeSlotsI[];
}

@Component({
    selector: 'app-store-page',
    templateUrl: './store-page.component.html',
    styleUrls: ['./store-page.component.scss'],
    standalone: true,
    imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule,
    MatTableModule,
    MatCardModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatListModule,
    MatIconModule,
    MatStepperModule,
    ProgressComponent,
    CommonModule
]
})
export class StorePageComponent implements OnInit {
  canEditStoreInfo: boolean = false;
  createActivity: boolean = false;
  storePanelExpanded: boolean = true;
  storeId!: string;
  storeData!: any;
  storeActivities: any[] = [];
  newlyCreatedActivity!: any;
  activityHeaders: string[] = ["activity-name", "activity-mainActivityType", "activity-description", "activity-view-page", "activity-actions"];
  reuseActivityId?: string;
  formDisabled: boolean = true;
  mainActivityOptions: string[] = [
    'Snorkeling',
    'Diving',
    'Boat Tours',
    'Bus Tours',
    'Beach Tours',
    'ATV Tours',
    'Hiking',
    'Cultural Tours',
    'Hotel',
    'Car Rental'
  ];
  durationOptions: string[] = ['1-3 hours', '3-5 hours', '5-7 hours', 'Full day (7+ hours)', 'Multi-day'];
  languageOptions: string[] = ['English', 'Spanish', 'Dutch', 'Papiamento'];
  currencyOptions: { value: string; label: string }[] = [
    { value: 'USD', label: 'USD - US Dollar' },
    { value: 'EUR', label: 'EUR - Euro' },
    { value: 'ANG', label: 'ANG - Netherlands Antillean Guilder' }
  ];
  dateSelected: Date | null;
  dateRangeStart: Date | null;
  dateRangeEnd: Date | null;
  dateMode: 'single' | 'bulk' = 'single';
  activityId!: string;
  availability: AvailabilityI[] = [];
  activityName: string = "";
  mapPoint: any = {
    description: "",
    googleMapPoint: ""
  };
  importantInfo: any = {
    title: "",
    info: ""
  };

  @ViewChild(MatTable) table: MatTable<any>;
  @ViewChild('stepper') stepper!: MatStepper;

  constructor(
    private _Activatedroute: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    private service: ServiceService,
    private storageService: StorageService
  ) { }

  storeInfo = this.formBuilder.group({
    storeDataName: new FormControl({value: '', disabled: true}),
    storeDescription: new FormControl({value: '', disabled: true}),
    storeDataAddress: new FormControl({value: '', disabled: true}),
    storeDataCity: new FormControl({value: '', disabled: true}),
    storeDataEmail: new FormControl({value: '', disabled: true}),
    storeDataPhone: new FormControl({value: '', disabled: true}),
  });

  editStoreInfo() {
    this.storeInfo.controls.storeDataName.enable();
    this.storeInfo.controls.storeDescription.enable();
    this.storeInfo.controls.storeDataAddress.enable();
    this.storeInfo.controls.storeDataCity.enable();
    this.storeInfo.controls.storeDataEmail.enable();
    this.storeInfo.controls.storeDataPhone.enable();

    this.canEditStoreInfo = true;
  }

  saveStoreInfo() {
    // TODO: Implement store update with Amplify Gen 2
    console.log('Store info updated:', this.storeInfo.value);
    
    this.storeInfo.controls.storeDataName.disable();
    this.storeInfo.controls.storeDescription.disable();
    this.storeInfo.controls.storeDataAddress.disable();
    this.storeInfo.controls.storeDataCity.disable();
    this.storeInfo.controls.storeDataEmail.disable();
    this.storeInfo.controls.storeDataPhone.disable();

    this.canEditStoreInfo = false;
  }

  toggleStorePanel() {
    this.storePanelExpanded = !this.storePanelExpanded;
  }

  cancelEditStoreInfo() {
    // Reset form and disable editing
    this.storeInfo.controls.storeDataName.disable();
    this.storeInfo.controls.storeDescription.disable();
    this.storeInfo.controls.storeDataAddress.disable();
    this.storeInfo.controls.storeDataCity.disable();
    this.storeInfo.controls.storeDataEmail.disable();
    this.storeInfo.controls.storeDataPhone.disable();
    
    this.canEditStoreInfo = false;
  }

  createNewActivityAbout = this.formBuilder.group({
    activityName: ['', Validators.required],
    mainActivityType: new FormControl,
    activityDescription: ['', Validators.required],
    activityFullDescription: new FormControl,
  });

  createNewActivitySettings = this.formBuilder.group({
    topPickCtrl: [false, Validators.required],
    durationCtrl: ['', Validators.required],
    sellOutCtrl: [false, Validators.required],
    languageCtrl: ['English', Validators.required],
    pricePerPerson: [0, Validators.required],
    discountPricePercentage: [0, Validators.required],
    currencyCtrl: ['USD', Validators.required],
    sumbitActivityData: new FormControl({disabled: true}),
  });

  createNewActivityTimeDates = this.formBuilder.group({
    timeOfDayCtrl: [''], // Optional - kept for compatibility
    timeSlotLabel1: ['Morning: 8 AM-12 PM'],
    numberOfSlots1: [0], // Optional - only validate if at least one slot > 0
    timeSlotLabel2: ['Afternoon: 12 PM-5 PM'],
    numberOfSlots2: [0],
    timeSlotLabel3: ['Evening: 5 PM-12 AM'],
    numberOfSlots3: [0],
  });



  createNewActivityPictures = this.formBuilder.group({
    pictureFileDrop: new FormControl
  });

  ngOnInit() {
    this.storeId = this._Activatedroute.snapshot.params["id"];
    console.log("storeid", this.storeId);

    // Check for reuse activity query param
    this.reuseActivityId = this._Activatedroute.snapshot.queryParams["reuseActivityId"];
    if (this.reuseActivityId) {
      const activityName = this._Activatedroute.snapshot.queryParams["activityName"];
      this.openSnackBar(`Reusing activity: ${activityName || this.reuseActivityId}. Please add new availability slots.`, 'Close');
      // Load the activity details to populate forms
      this.loadActivityForReuse(this.reuseActivityId);
    }

    this.loadStoreData();
    this.loadActivities();
  }

  loadActivityForReuse(activityId: string) {
    this.service.getActivityById(activityId).subscribe({
      next: (activity) => {
        if (activity) {
          // Populate forms with activity data
          this.createNewActivityAbout.patchValue({
            activityName: activity.name,
            mainActivityType: activity.mainActivityType,
            activityDescription: activity.description,
            activityFullDescription: activity.fullDescription
          });
          
          this.createNewActivitySettings.patchValue({
            topPickCtrl: activity.topPick,
            durationCtrl: activity.duration,
            sellOutCtrl: activity.sellOut,
            languageCtrl: activity.language,
            pricePerPerson: activity.pricePerPerson,
            discountPricePercentage: activity.discountedPrice || 0,
            currencyCtrl: activity.currencyType
          });

          // Set the activity ID for availability and pictures
          this.activityId = activity.id;
          
          // Navigate to availability step (using setTimeout to ensure stepper is initialized)
          setTimeout(() => {
            if (this.stepper) {
              this.stepper.selectedIndex = 2; // Availability step
            }
          }, 100);
        }
      },
      error: (error) => {
        console.error('Error loading activity for reuse:', error);
        this.openSnackBar('Error loading activity details', 'Close');
      }
    });
  }

  archiveActivity(activityId: string) {
    if (confirm('Are you sure you want to archive this activity? It will no longer appear in the main display.')) {
      this.service.archiveActivity(activityId).subscribe({
        next: () => {
          this.openSnackBar('Activity archived successfully', 'Close');
          this.loadActivities();
        },
        error: (error) => {
          console.error('Error archiving activity:', error);
          this.openSnackBar('Failed to archive activity', 'Close');
        }
      });
    }
  }

  editActivity(activity: any) {
    // Load activity data and populate forms for editing
    this.loadActivityForReuse(activity.id);
    
    // Set editing mode
    this.editingActivityId = activity.id;
    this.createActivity = true;
    
    // Navigate to first step
    setTimeout(() => {
      if (this.stepper) {
        this.stepper.selectedIndex = 0;
      }
    }, 100);
  }

  deleteActivity(activityId: string, activityName: string) {
    const confirmMessage = `Are you sure you want to PERMANENTLY DELETE "${activityName}"?\n\nThis will:\n- Delete the activity from the system\n- Delete all associated images from storage\n- Delete all availability data\n- Delete all related information\n\nThis action CANNOT be undone!`;
    
    if (confirm(confirmMessage)) {
      // Double confirmation for destructive action
      if (confirm('This is your last chance. Are you absolutely sure you want to delete this activity?')) {
        console.log(`[DELETE] Starting deletion of activity: ${activityId} (${activityName})`);
        
        this.service.deleteActivity(activityId).subscribe({
          next: (result) => {
            console.log('[DELETE] Delete successful:', result);
            this.openSnackBar(`Activity "${activityName}" deleted permanently`, 'Close');
            this.loadActivities();
          },
          error: (error) => {
            console.error('[DELETE] Error deleting activity:', error);
            console.error('[DELETE] Error details:', JSON.stringify(error, null, 2));
            this.openSnackBar(`Failed to delete activity: ${error.message || 'Unknown error'}. Please check the console for details.`, 'Close');
          }
        });
      }
    }
  }

  editingActivityId?: string;

  navigateToArchive() {
    this.router.navigate(['/activity-archive'], {
      queryParams: { storeId: this.storeId }
    });
  }

  loadStoreData() {
    if (!this.storeId) return;
    
    this.service.getStoreById(this.storeId).subscribe({
      next: (store) => {
        console.log('Store loaded:', store);
        this.storeData = store;
        
        // Populate form with store data
        this.storeInfo.controls.storeDataName.setValue(store.name || '');
        this.storeInfo.controls.storeDescription.setValue(store.description || '');
        
        // Parse location to get address and city
        if (store.location) {
          const locationParts = store.location.split(',');
          this.storeInfo.controls.storeDataAddress.setValue(locationParts[0] || '');
          this.storeInfo.controls.storeDataCity.setValue(locationParts[1] || '');
        }
        
        this.storeInfo.controls.storeDataEmail.setValue(store.email || '');
        this.storeInfo.controls.storeDataPhone.setValue(store.phone || '');
      },
      error: (error) => {
        console.error('Error loading store:', error);
        this.openSnackBar('Error loading store data', 'Close');
      }
    });
  }

  loadActivities() {
    if (!this.storeId) return;
    
    this.service.getActivitiesByStoreId(this.storeId).subscribe({
      next: (activities) => {
        console.log('Activities loaded:', activities);
        this.storeActivities = activities;
      },
      error: (error) => {
        console.error('Error loading activities:', error);
        this.openSnackBar('Error loading activities', 'Close');
      }
    });
  }

  toggleDateMode() {
    this.setDateMode(this.dateMode === 'single' ? 'bulk' : 'single');
  }

  setDateMode(mode: 'single' | 'bulk') {
    if (this.dateMode === mode) {
      return;
    }
    this.dateMode = mode;
    this.dateSelected = null;
    this.dateRangeStart = null;
    this.dateRangeEnd = null;
  }

  getDateRange(): Date[] {
    if (this.dateMode === 'single') {
      return this.dateSelected ? [new Date(this.dateSelected)] : [];
    } else {
      // Bulk mode: generate all dates between start and end
      if (!this.dateRangeStart || !this.dateRangeEnd) return [];
      
      const dates: Date[] = [];
      const currentDate = new Date(this.dateRangeStart);
      const endDate = new Date(this.dateRangeEnd);
      
      while (currentDate <= endDate) {
        dates.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
      }
      
      return dates;
    }
  }

  saveBookingDateTime () {
    // Get slot values from individual inputs
    const slots1 = this.createNewActivityTimeDates.controls.numberOfSlots1.value || 0;
    const slots2 = this.createNewActivityTimeDates.controls.numberOfSlots2.value || 0;
    const slots3 = this.createNewActivityTimeDates.controls.numberOfSlots3.value || 0;
    const label1 = this.normalizeTimeSlotLabel(
      this.createNewActivityTimeDates.controls.timeSlotLabel1.value,
      'Morning: 8 AM-12 PM'
    );
    const label2 = this.normalizeTimeSlotLabel(
      this.createNewActivityTimeDates.controls.timeSlotLabel2.value,
      'Afternoon: 12 PM-5 PM'
    );
    const label3 = this.normalizeTimeSlotLabel(
      this.createNewActivityTimeDates.controls.timeSlotLabel3.value,
      'Evening: 5 PM-12 AM'
    );

    // Build time slots array only for slots with values > 0
    let timeSlotsValues: TimeSlotsI[] = [];

    if (slots1 > 0) {
      timeSlotsValues.push({
        timeSlot: label1,
        personSlots: slots1
      });
    }

    if (slots2 > 0) {
      timeSlotsValues.push({
        timeSlot: label2,
        personSlots: slots2
      });
    }

    if (slots3 > 0) {
      timeSlotsValues.push({
        timeSlot: label3,
        personSlots: slots3
      });
    }

    // Validate that at least one time slot has been configured
    if (timeSlotsValues.length === 0) {
      this.openSnackBar('Please enter at least one time slot with slots > 0', 'Close');
      return;
    }

    const twoDigitMonth = new Intl.DateTimeFormat("en-US", {
      month: "2-digit"
    })
    const twoDigitDay = new Intl.DateTimeFormat("en-US", {
      day: "2-digit"
    })
    
    // Get all selected dates
    const selectedDates = this.getDateRange();
    
    if (selectedDates.length === 0) {
      this.openSnackBar('Please select at least one date', 'Close');
      return;
    }

    // Save availability to database for each date
    selectedDates.forEach(date => {
      let dateFormatted = date.getFullYear() + '-' + twoDigitMonth.format(date) + '-' + twoDigitDay.format(date);
      
      let availability: AvailabilityI = {
        availabilityDate: date.getTime(),
        dateFormated: dateFormatted,
        timeSlots: timeSlotsValues
      }
      
      this.availability.push(availability);
      
      // Save to database if activityId is available
      if (this.activityId) {
        const availabilityData = {
          date: dateFormatted,
          formattedDate: dateFormatted,
          timeSlots: JSON.stringify(timeSlotsValues),
          activityID: this.activityId
        };
        
        this.service.createAvailability(availabilityData as any).subscribe({
          next: () => {
            console.log('Availability saved for date:', dateFormatted);
          },
          error: (error) => {
            console.error('Error saving availability:', error);
          }
        });
      }
    });

    // Clear selections after adding
    if (this.dateMode === 'single') {
      this.dateSelected = null;
    } else {
      this.dateRangeStart = null;
      this.dateRangeEnd = null;
    }
    
    this.openSnackBar(`Added ${selectedDates.length} date(s) to availability`, 'Close');
  }

  private normalizeTimeSlotLabel(value: unknown, fallback: string): string {
    const label = String(value || '').trim();
    return label || fallback;
  }
  activityBoxShow() {
    this.createActivity = true;
  }

  activityBoxHide() {
    this.createActivity = false;
  }


  openDialog(): void {
    const dialogRef = this.dialog.open(ShowNewActivityCreation, {
      data: { storeId: this.storeId},
    });
  }

  onClickGo(id: string) {

    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/activity-booking/', id])
    );

    window.open(url, '_blank');
  }

  private modalService = inject(NgbModal);
	closeResult = '';

	open(content: TemplateRef<any>) {
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then(
			(result) => {
				this.closeResult = `Closed with: ${result}`;
			},
			(reason) => {
				this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
			},
		);
	}

	private getDismissReason(reason: any): string {
		switch (reason) {
			case ModalDismissReasons.ESC:
				return 'by pressing ESC';
			case ModalDismissReasons.BACKDROP_CLICK:
				return 'by clicking on a backdrop';
			default:
				return `with: ${reason}`;
		}
	}



  onSettingsStepCompleted() {
    // Create or update activity when settings step is completed
    if (this.createNewActivityAbout.invalid || this.createNewActivitySettings.invalid) {
      this.openSnackBar('Please fill in all required fields', 'Close');
      return;
    }

    const activityData = {
      name: this.createNewActivityAbout.controls.activityName.value,
      description: this.createNewActivityAbout.controls.activityDescription.value,
      fullDescription: this.createNewActivityAbout.controls.activityFullDescription.value,
      mainActivityType: this.createNewActivityAbout.controls.mainActivityType.value,
      storeID: this.storeId,
      topPick: this.createNewActivitySettings.controls.topPickCtrl.value,
      sellOut: this.createNewActivitySettings.controls.sellOutCtrl.value,
      duration: this.createNewActivitySettings.controls.durationCtrl.value,
      language: this.createNewActivitySettings.controls.languageCtrl.value,
      pricePerPerson: this.createNewActivitySettings.controls.pricePerPerson.value,
      discountedPrice: this.calculateDiscountedPrice(),
      currencyType: this.createNewActivitySettings.controls.currencyCtrl.value,
      // Default values for required fields (only for new activities)
      productId: '',
      favorite: false,
      bookingTag: 0,
      bookingTagActive: false,
      amenityTags: '',
      searchTags: '',
      rating: 0,
      reviews: 0,
      peoplePerPrice: 1,
      highlights: '',
      notSuitable: '',
      startDate: '',
      endDate: ''
    };

    // Check if we're editing an existing activity
    if (this.editingActivityId) {
      // Update existing activity
      this.service.updateActivity(this.editingActivityId, activityData as any).subscribe({
        next: (activity) => {
          console.log('Activity updated:', activity);
          if (!activity || !activity.id) {
            this.openSnackBar('Activity was updated but returned no id. Please try again.', 'Close');
            return;
          }
          this.activityId = activity.id;
          this.activityName = activity.name;
          
          // Move to next step (Dates & Availability)
          if (this.stepper) {
            this.stepper.next();
          }
          
          this.openSnackBar('Activity updated successfully! You can now manage availability dates.', 'Close');
          // Refresh activities list
          this.loadActivities();
          // Clear editing mode
          this.editingActivityId = undefined;
        },
        error: (error) => {
          console.error('Error updating activity:', error);
          this.openSnackBar('Error updating activity. Please try again.', 'Close');
        }
      });
    } else {
      // Create new activity
      this.service.createActivity(activityData as any).subscribe({
        next: (activity) => {
          console.log('Activity created:', activity);
          if (!activity || !activity.id) {
            this.openSnackBar('Activity was created but returned no id. Please try again.', 'Close');
            return;
          }
          this.activityId = activity.id;
          this.activityName = activity.name;
          
          // Move to next step (Dates & Availability)
          if (this.stepper) {
            this.stepper.next();
          }
          
          this.openSnackBar('Activity created successfully! You can now add availability dates.', 'Close');
          // Refresh activities list
          this.loadActivities();
        },
        error: (error) => {
          console.error('Error creating activity:', error);
          this.openSnackBar('Error creating activity. Please try again.', 'Close');
        }
      });
    }
  }

  saveAvailabilityForActivity() {
    if (!this.activityId || this.availability.length === 0) return;

    const twoDigitMonth = new Intl.DateTimeFormat("en-US", { month: "2-digit" });
    const twoDigitDay = new Intl.DateTimeFormat("en-US", { day: "2-digit" });

    this.availability.forEach(avail => {
      const date = new Date(avail.availabilityDate);
      const dateFormatted = date.getFullYear() + '-' + twoDigitMonth.format(date) + '-' + twoDigitDay.format(date);
      
      const availabilityData = {
        date: dateFormatted,
        formattedDate: dateFormatted,
        timeSlots: JSON.stringify(avail.timeSlots),
        activityID: this.activityId
      };

      this.service.createAvailability(availabilityData as any).subscribe({
        next: () => console.log('Availability saved for date:', dateFormatted),
        error: (error) => console.error('Error saving availability:', error)
      });
    });
  }

  calculateDiscountedPrice(): number {
    const pricePerPerson = this.createNewActivitySettings.controls.pricePerPerson.value || 0;
    const discountPercentage = this.createNewActivitySettings.controls.discountPricePercentage.value || 0;
    return pricePerPerson * (1 - discountPercentage / 100);
  }

  resetActivityCreation() {
    this.createNewActivityAbout.reset();
    this.createNewActivityTimeDates.reset({
      timeOfDayCtrl: '',
      timeSlotLabel1: 'Morning: 8 AM-12 PM',
      numberOfSlots1: 0,
      timeSlotLabel2: 'Afternoon: 12 PM-5 PM',
      numberOfSlots2: 0,
      timeSlotLabel3: 'Evening: 5 PM-12 AM',
      numberOfSlots3: 0,
    });
    this.createNewActivitySettings.reset({
      topPickCtrl: false,
      durationCtrl: '',
      sellOutCtrl: false,
      languageCtrl: 'English',
      pricePerPerson: 0,
      discountPricePercentage: 0,
      currencyCtrl: 'USD',
      sumbitActivityData: undefined,
    });
    this.createNewActivityPictures.reset();
    this.availability = [];
    this.activityId = '';
    this.editingActivityId = undefined;
    this.dateSelected = null;
    this.dateRangeStart = null;
    this.dateRangeEnd = null;
    
    if (this.stepper) {
      this.stepper.reset();
    }
  }

  async addPictures(activityId: string) {
    if (!activityId) {
      this.openSnackBar('Please create the activity first', 'Close');
      return;
    }

    if (this.files.length === 0) {
      this.openSnackBar('Please select at least one file to upload', 'Close');
      return;
    }

    // Validate all files before uploading
    const invalidFiles = this.files.filter(fileItem => {
      const validation = this.storageService.validateFile(fileItem.file);
      if (!validation.valid) {
        return true;
      }
      return false;
    });

    if (invalidFiles.length > 0) {
      this.openSnackBar('Some files are invalid. Please check file types and sizes.', 'Close');
      return;
    }

    // Upload files sequentially
    let successCount = 0;
    let errorCount = 0;
    const totalFiles = this.files.length;

    for (let i = 0; i < this.files.length; i++) {
      const fileItem = this.files[i];
      const actualFile = fileItem.file; // Get the actual File object
      
      try {
        // Set initial progress
        fileItem.progress = 10;

        // Upload file to S3
        const uploadResult = await this.storageService.uploadActivityPicture(actualFile, activityId);
        
        if (uploadResult.success) {
          fileItem.progress = 80;
          
          // Create Picture record in database
          const pictureData = {
            url: uploadResult.url,
            description: fileItem.name,
            activityID: activityId
          };

          this.service.createPicture(pictureData as any).subscribe({
            next: (picture) => {
              console.log('Picture created:', picture);
              fileItem.progress = 100;
              successCount++;
              
              // Check if all files are done
              if (successCount + errorCount === totalFiles) {
                this.handleUploadComplete(successCount, errorCount);
              }
            },
            error: (error) => {
              console.error('Error creating picture record:', error);
              fileItem.progress = 0;
              fileItem.error = 'Failed to create picture record';
              errorCount++;
              
              if (successCount + errorCount === totalFiles) {
                this.handleUploadComplete(successCount, errorCount);
              }
            }
          });
        } else {
          fileItem.progress = 0;
          fileItem.error = uploadResult.error || 'Upload failed';
          errorCount++;
          
          if (successCount + errorCount === totalFiles) {
            this.handleUploadComplete(successCount, errorCount);
          }
        }
      } catch (error) {
        console.error('Error uploading file:', error);
        fileItem.progress = 0;
        fileItem.error = error instanceof Error ? error.message : 'Unknown error';
        errorCount++;
        
        if (successCount + errorCount === totalFiles) {
          this.handleUploadComplete(successCount, errorCount);
        }
      }
    }
  }

  handleUploadComplete(successCount: number, errorCount: number) {
    if (successCount > 0 && errorCount === 0) {
      this.openSnackBar(`Successfully uploaded ${successCount} picture(s)`, 'Close');
      // Clear successfully uploaded files
      this.files = this.files.filter(f => f.progress !== 100);
    } else if (successCount > 0 && errorCount > 0) {
      this.openSnackBar(`Uploaded ${successCount} picture(s), ${errorCount} failed`, 'Close');
      // Clear successfully uploaded files
      this.files = this.files.filter(f => f.progress !== 100);
    } else {
      this.openSnackBar(`Failed to upload pictures. Please try again.`, 'Close');
    }
  }

  /**
   * Complete the pictures step
   */
  onPicturesStepCompleted() {
    // If there are files queued but not uploaded, inform the user
    const unuploadedFiles = this.files.filter(f => f.progress !== 100 && f.progress !== 0);
    if (unuploadedFiles.length > 0) {
      this.openSnackBar('Please upload all pictures before completing this step', 'Close');
      return;
    }

    // Pictures step is optional, so we can always complete it
    this.openSnackBar('Activity creation completed!', 'Close');
    
    // Reset the form and stepper
    this.resetActivityCreation();
  }

  files: any[] = [];

  /**
   * on file drop handler
   */
  onFileDropped($event: FileList) {
    const fileArray = Array.from($event);
    this.prepareFilesList(fileArray);
  }

  /**
   * handle file from browsing
  */
  fileBrowseHandler(files: FileList | null) {
    if (!files) return;
    const fileArray = Array.from(files);
    this.prepareFilesList(fileArray);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

  /**
   * Convert Files list to normal array list and validate
   * @param files (Files List)
   */
  prepareFilesList(files: File[]) {
    const newFiles: any[] = [];
    
    for (const file of files) {
      // Validate file
      const validation = this.storageService.validateFile(file, 10); // 10MB max
      
      if (!validation.valid) {
        this.openSnackBar(`File ${file.name}: ${validation.error}`, 'Close');
        continue;
      }

      const fileWithProgress = {
        name: file.name,
        size: file.size,
        type: file.type,
        file: file,
        progress: 0,
        error: undefined as string | undefined
      };
      
      newFiles.push(fileWithProgress);
    }
    
    if (newFiles.length > 0) {
      this.files.push(...newFiles);
      this.openSnackBar(`Added ${newFiles.length} file(s) to upload queue`, 'Close');
    }
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals = 0.00) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action,
      {
        horizontalPosition: "center",
        verticalPosition: "top"
      }
    );
  }
}

@Component({
    selector: 'show-new-activity-creation',
    templateUrl: 'show-new-activity-creation.html',
    standalone: true,
    imports: [MatDialogModule, ActivityCreationPageComponent]
})
export class ShowNewActivityCreation {
  constructor(
    public dialogRef: MatDialogRef<ShowNewActivityCreation>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
